import { ArenaRealtimeTokenResponseSchema } from '@sweetistics/contracts';
import type { z } from 'zod';

export type ArenaRealtimeTokenResponseInput = z.input<typeof ArenaRealtimeTokenResponseSchema>;
export type ArenaRealtimeTokenResponseOutput = z.output<typeof ArenaRealtimeTokenResponseSchema>;

export function serializeArenaRealtimeTokenResponse(
  payload: ArenaRealtimeTokenResponseInput
): ArenaRealtimeTokenResponseOutput {
  return ArenaRealtimeTokenResponseSchema.parse(payload);
}
